export default function isArrayBuffer(arrayBuffer: ArrayBuffer): boolean {
  const enc = new TextDecoder('utf-8');
  const textResponse = enc.decode(arrayBuffer);
  try {
    const parsedResponse = JSON.parse(textResponse);
    console.log({ parsedResponse });
    return false;
  } catch (err) {
    return true;
  }
}
